enum DROPDOWN_TYPES {
    TOP = <any> 'TOP',
    LEFT = <any> 'LEFT',
}

export default DROPDOWN_TYPES;


// WEBPACK FOOTER //
// ./src/app/enums/dropdownTypes.enum.ts